import { create } from "zustand";

type StateType = {
	isLoading: boolean;
	setIsLoading: (loading: boolean) => void;
};

export const LoadingStore = create<StateType>((set) => ({
	isLoading: false,
	setIsLoading: (loading: boolean) => set({ isLoading: loading }),
}));
